import Markdown from "@/components/atoms/Markdown";
import styles from "./CampusCard.module.scss";
import cn from "clsx";
import addLineBreaks from "@/helpers/addLineBreaks";
import Image from "next/image";

export default function CampusEmersionCard({
  imageData,
  isTitleOnly = false,
}: {
  imageData: ImageWithText;
  isTitleOnly?: boolean;
}) {
  return (
    <div className={cn("border-primary-blu", styles.AdvantageCard__container)}>
      <div className={cn(styles.ProgramHighlight_img)}>
        <Image
          src={imageData?.Image?.data?.attributes?.url}
          alt={imageData?.Image?.data?.attributes?.alternativeText ||'Program highlights'}
          title="Program highlights"
          className={cn(
            "object-cover h-full w-full",
            "border-primary-blu",
            styles.AdvantageCard__image,
          )}
          width={290}
          height={160}
        />
      </div>
      <div
        className={cn("font-raleway ", styles.AdvantageCard__textContainer, {
          [styles.AdvantageCard__titleOnly]: isTitleOnly,
        })}
      >
        <h3 className={cn("text-primary-blue", styles.AdvantageCard__title)}>
          <Markdown>{addLineBreaks(imageData?.Title)}</Markdown>
        </h3>
      </div>
    </div>
  );
}
